module.exports = __webpack_public_path__ + "static/img/11.7df8c9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/11.svg
// module id = EE7O
// module chunks = 0